/**
 *
 */



class UserCustomOperator {

	constructor(or34, resultDataNb) {

		this._or34 = or34;

		this._resultDataNb = resultDataNb;

		this._btStyle1 = {   trueBg: '#333377',
									falseBg: '#fcfcfc',
									trueColor: '#ffffff',
									falseColor: '#222222' };

		this._btStyle2 = {   trueBg: 'linear-gradient( 353deg, Khaki, Yellow)',
									falseBg: 'linear-gradient( 353deg, #4280a7, #69a3d2)',
									trueColor: '#222222',
									falseColor: '#ffffff' };


		this._btStyle = this._btStyle1;

		this._checkBoxKey = [ 'jik', 'jyo', 'fuk', 'cho', 'rea' ];
		this._checkBoxIdStr = [ 'btS', 'btJ', 'btF', 'btC', 'btR' ];
		//
		this._checkBoxJiku = new CheckBox_Jiku(or34);
		this._checkBoxJyogai = new CheckBox_Jyogai(or34);


		this._checkBoxFuku = new CheckBox_Fuku(or34, resultDataNb);  //  new

		this._checkBoxCho = new CheckBox_Cho(or34);
		this._checkBoxRea = new CheckBox_Rea(or34);
		//
		this.checkBoxMap = new Map();
		this.checkBoxMap.set(this._checkBoxKey[0], this._checkBoxJiku);
		this.checkBoxMap.set(this._checkBoxKey[1], this._checkBoxJyogai);

		this.checkBoxMap.set(this._checkBoxKey[2], this._checkBoxFuku);   //  new

		this.checkBoxMap.set(this._checkBoxKey[3], this._checkBoxCho);
		this.checkBoxMap.set(this._checkBoxKey[4], this._checkBoxRea);

	};


	get checkBoxKey() {   return this._checkBoxKey;   };

	getCheckBox(key) {
		return this.checkBoxMap.get(key);
	};


	getUserCustomList() {
		let objList = [];
		for(let i=0, n=this._checkBoxKey.length; i<n; i++) {
			let checkBox = this.checkBoxMap.get(this._checkBoxKey[i]);

			let chList = checkBox.userCustomObjList();
			for(let j=0, n=chList.length; j<n; j++) {

				objList.push( chList[j] );
			};
		};
		return objList;
	};

	getUserCustomStateObj() {

		let stateObj = {};
		for(let i=0, n=this._checkBoxKey.length; i<n; i++) {
			let checkBox = this.checkBoxMap.get(this._checkBoxKey[i]);

			stateObj[this._checkBoxKey[i]] = checkBox.userCustomStateObj();
		};
		return stateObj;
	};

	setUserCustomStateObj(stateObj) {

		if(stateObj) {
			for(let i=0, n=this._checkBoxKey.length; i<n; i++) {
				let checkBox = this.checkBoxMap.get(this._checkBoxKey[i]);

				let obj = stateObj[this._checkBoxKey[i]];
				if( obj ) {
					checkBox.setStateObj( obj );
				};
			};
		};
	};



	//  DOM

	pushS(val) {

		this._checkBoxJiku.click(val);
		this._checkBoxJyogai.bindArray( this._checkBoxJiku.boxBooArr );

		this.pushSJDOM( val );
	};
	pushJ(val) {

		this._checkBoxJyogai.click(val);
		this._checkBoxJiku.bindArray( this._checkBoxJyogai.boxBooArr );
		this._checkBoxFuku.bindArray( this._checkBoxJyogai.boxBooArr );  //  new add

		this.pushSJDOM( val );
	};
	pushF(val) {     //  new

		this._checkBoxFuku.click(val);
		this._checkBoxJyogai.bindArray( this._checkBoxFuku.boxBooArr );  //  new add
		this.pushSJDOM( val );

		this.fukuResetBtStyleChange(this._checkBoxFuku);
	};

	pushSJDOM( val ) {

		this.setElementColorStyle( 'btS'+val, this._btStyle, this._checkBoxJiku.getIndexBoo(val));
		this.setElementColorStyle( 'btJ'+val, this._btStyle, this._checkBoxJyogai.getIndexBoo(val));
		this.setElementColorStyle( 'btF'+val, this._btStyle, this._checkBoxFuku.getIndexBoo(val));   //  new add
	};

	pushC(val) {

		this._checkBoxCho.click(val);

		this.setElementColorStyle( 'btC'+0, this._btStyle, this._checkBoxCho.getIndexBoo(0));
		this.setElementColorStyle( 'btC'+1, this._btStyle, this._checkBoxCho.getIndexBoo(1));
	};

	pushR(val) {

		this._checkBoxRea.click(val);

		this.setElementColorStyle( 'btR'+0, this._btStyle, this._checkBoxRea.getIndexBoo(0));
	};




	setAllBtStyle() {
		for(let i=0, n=this._checkBoxKey.length; i<n; i++) {
			let checkBox = this.checkBoxMap.get(this._checkBoxKey[i]);
			let boxBooArr = checkBox.boxBooArr;

			for(let j=0, m=boxBooArr.length; j<m; j++) {

				this.setElementColorStyle( this._checkBoxIdStr[i]+j, this._btStyle, boxBooArr[j]);
			};

			if(this._checkBoxKey[i]==='fuk') {   this.fukuResetBtStyleChange(checkBox);   };
		};
	};

	//  チェックボックス リセット
	checkBoxRt(val) {

		let checkBox = this.checkBoxMap.get(this._checkBoxKey[val]);
		checkBox.clear();
		this.btStyleReset(val, checkBox);

		if(this._checkBoxKey[val]==='fuk') {
			this.fukuResetBtStyleChange(checkBox);

			this._checkBoxJyogai.bindArray( this._checkBoxFuku.boxBooArr );  //  new add
			this.btStyleReset( 1, this._checkBoxJyogai);                     //  new add
		};
	};

	btStyleReset(val, checkBox) {

		let idStr = this._checkBoxIdStr[val];
		let booArr = checkBox.boxBooArr;
		for(let i=0, n=booArr.length; i<n; i++) {
			this.setElementColorStyle( idStr+i, this._btStyle, booArr[i]);
		};
	};
	
	fukuResetBtStyleChange(checkBox) {
		if(checkBox.getTrueNumerArray().length>0) {
			document.getElementById( 'chRt2').value = 'リセット';
		}else {
			document.getElementById( 'chRt2').value = '引張り';
		};
	};

	setElementColorStyle(idStr, styleObj, boo=true) {
		var style = document.getElementById(idStr).style;
		if(boo) {
			style.background = styleObj.trueBg;
			style.color = styleObj.trueColor;
		}else {
			style.background = styleObj.falseBg;
			style.color = styleObj.falseColor;
		}

	};





};

